import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Button,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import * as React from "react";
import { useRecordContext } from "react-admin";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import CustomProductCheckboxGroup from "../../unit/forms/CustomProductCheckboxGroup";
import CustomProductIntTextField from "../../unit/forms/CustomProductIntTextField";
import CustomProductNumberTextField from "../../unit/forms/CustomProductNumberTextField";
import CustomProductSelect from "../../unit/forms/CustomProductSelect";
import CustomProductTextField from "../../unit/forms/CustomProductTextField";
import FieldTitle from "./FieldTitle";
import SectionStyled from "./SectionStyled";
import SectionTitle from "./SectionTitle";
import CustomProductActionBottom from "../CustomProductActionBottom";

export default function Terms({ onSave, defaultValues, ...props }: any) {
  const [showSubmitButton, setShowSubmitButton] = React.useState(false);
  const [showMatchingAmount, setShowMatchingAmount] = React.useState(false);
  const [showMoreRateSettings, setShowMoreRateSettings] = React.useState(false);
  const [showLateFeeSetting, setShowLateFeeSetting] = React.useState(false);
  const [showLateFeeDefault, setShowLateFeeDefault] = React.useState(false);
  const [showGracePeriodCustom, setShowGracePeriodCustom] =
    React.useState(false);
  const [showGracePeriodSetting, setShowGracePeriodSetting] =
    React.useState(false);
  const [interestratetype, setInterestRateType] = React.useState("");
  const [groups, setGroups] = React.useState<{ title: string; rate: string }[]>(
    []
  );
  const [groupsTechnical, setGroupsTechnical] = React.useState<
    { title: string; rate: string }[]
  >([]);
  const [groupsDiscount, setGroupsDiscount] = React.useState<
    { title: string; rate: string }[]
  >([]);
  // const [stepRateGroup, setStepRateGroup] = React.useState<
  //   { rate: string; month: string }[]
  //   >([]);
  const [stepRateGroup, setStepRateGroup] = React.useState<
    { rate: string; month: string }[]
  >([]);
  const record = useRecordContext();
  const data = record?.data?.basic?.terms;
  const [stepTermsData, setStepTermsData] = React.useState(data?.stepTermsData);
  const subType = record?.data?.basic?.subType;
  const productModulesGroup = record?.data?.basic?.productModulesGroup;

  const loanTypeList = data?.loanTypeList || [];
  const loanTypeOptions = loanTypeList.map((item: any) => ({
    id: item.id,
    label: item.sLoanType,
  }));
  const loanAmortizationList = data?.loanAmortizationList || [];
  const loanAmortizationOptions = loanAmortizationList.map((item: any) => ({
    id: item.id,
    label: item.sAmortization,
  }));

  const [selectedLoanType, setSelectedLoanType] = React.useState(
    data?.selectLoanProductType || []
  );
  const [selectedAmortization, setSelectedAmortization] = React.useState(
    data?.selectProductloanAmortization || []
  );
  const [selectedAccountService, setSelectAccountService] = React.useState(
    data?.selectAccountService || []
  );

  const accountserviceOptions: any = [];
  accountserviceOptions.push({
    id: "savings-account",
    label: "Savings Account",
    value: "06",
  });
  accountserviceOptions.push({
    id: "checking-account",
    label: "Checking Account",
    value: "05",
  });
  accountserviceOptions.push({
    id: "checking-debit-card",
    label: "Debit Card",
    level: "2",
    value: "0508",
  });
  accountserviceOptions.push({
    id: "checking-check-order",
    label: "Check Order",
    level: "2",
    value: "0506",
  });
  accountserviceOptions.push({
    id: "checking-overdraft-protection",
    label: "Overdraft Protection",
    level: "2",
    value: "0507",
  });
  accountserviceOptions.push({
    id: "money-market",
    label: "Money Market",
    value: "03",
  });
  accountserviceOptions.push({ id: "cds", label: "CDs", value: "04" });

  const buildInitialValues = () => {
    if (data) {
      let sPaymentFrequencyPermitted = data?.sPaymentFrequencyPermitted;
      //  = sPaymentFrequencyPermitted? 用逗号拆分成数组
      let payFrequencyPermittedArr = sPaymentFrequencyPermitted.split(",");
      let latefee_custom = data?.latefee?.latefee_custom;
      let graceperiod_custom = data?.gracePeriod?.graceperiod_custom;
      const normalizeGracePeriodValue = (value: any) => {
        if (value === null || value === undefined) {
          return "";
        }
        return String(value);
      };
      return {
        sApplicantEnterLoanAmount: data?.sApplicantEnterLoanAmount || "NO",
        sApplicantChooseLoanTerm: data?.sApplicantChooseLoanTerm || "NO",
        sApplicantChoosePaymentFrequency:
          data?.sApplicantChoosePaymentFrequency || "NO",
        sAllowPaymentDueDate: data?.sAllowPaymentDueDate || "NO",
        amount_min: data?.amount?.amount_min || 0,
        amount_max: data?.amount?.amount_max || 0,
        amount_increment: data?.amount?.amount_increment || 0,
        matchedSavingsoffer:
          data?.matchMaxAmount?.max_match_amount > 0 ? "YES" : "NO",
        max_match_amount: data?.matchMaxAmount?.max_match_amount || "",
        term_min: data?.term?.term_min || 0,
        term_max: data?.term?.term_max || 0,
        term_increment: data?.term?.term_increment || 0,
        prepaymentPenalty_min:
          data?.prepaymentPenalty?.prepaymentPenalty_min || 0.0,
        prepaymentPenalty_max:
          data?.prepaymentPenalty?.prepaymentPenalty_max || 0.0,
        prepaymentPenalty_increment:
          data?.prepaymentPenalty?.prepaymentPenalty_increment || 0.0,
        rate_min: data?.rate?.rate_min || 0.0,
        rate_max: data?.rate?.rate_max || 0.0,
        rate_increment: data?.rate?.rate_increment || 0.0,
        pledged_min: data?.pledged?.pledged_min || 0.0,
        pledged_max: data?.pledged?.pledged_max || 0.0,
        pledged_increment: data?.pledged?.pledged_increment || 0.0,
        purchases_rate: data?.purchases_rate || 0.0,
        balance_transfer_rate: data?.balance_transfer_rate || 0.0,
        cash_advance_rate: data?.cash_advance_rate || 0.0,
        penalty_rate: data?.penalty_rate || 0.0,
        allowZerorate: data?.rate?.allowZerorate || "",
        payment_frequency_permitted: payFrequencyPermittedArr || [],
        graceperiod_adjust: data?.gracePeriod?.graceperiod_adjust || "",
        latefee_adjust: data?.latefee?.latefee_adjust || "",
        latefee_adjust_custom: data?.latefee?.latefee_adjust_custom || "",
        // latefee_custom: data?.latefee?.latefee_custom || "",
        latefee_paymentfrequency_M11: latefee_custom?.M11 || "",
        latefee_paymentfrequency_M12: latefee_custom?.M12 || "",
        latefee_paymentfrequency_M13: latefee_custom?.M13 || "",
        latefee_paymentfrequency_W11: latefee_custom?.W11 || "",
        latefee_paymentfrequency_W21: latefee_custom?.W21 || "",
        latefee_paymentfrequency_ONCE: latefee_custom?.ONCE || "",
        latefee_max: data?.latefee?.latefee_max || "",
        latefee_min: data?.latefee?.latefee_min || "",
        latefee_increment: data?.latefee?.latefee_increment || "",
        latefee_unit: data?.latefee?.latefee_unit || "Amount",
        graceperiod_paymentfrequency_M11: normalizeGracePeriodValue(
          graceperiod_custom?.M11
        ),
        graceperiod_paymentfrequency_M12: normalizeGracePeriodValue(
          graceperiod_custom?.M12
        ),
        graceperiod_paymentfrequency_M13: normalizeGracePeriodValue(
          graceperiod_custom?.M13
        ),
        graceperiod_paymentfrequency_W11: normalizeGracePeriodValue(
          graceperiod_custom?.W11
        ),
        graceperiod_paymentfrequency_W21: normalizeGracePeriodValue(
          graceperiod_custom?.W21
        ),
        graceperiod_paymentfrequency_ONCE: normalizeGracePeriodValue(
          graceperiod_custom?.ONCE
        ),
        interest_rate_type: data?.spreadRate?.sInterestRateType || "",
        baserate: data?.spreadRate?.dBaseRate || "",
        useMarketRate: data?.spreadRate?.sUseMarketRate || "NO",
      };
    }
  };
  const initialValues = buildInitialValues();

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm<any>({
    mode: "onBlur",
    defaultValues: initialValues || {},
  });
  const amountMin = watch("amount_min");
  const amountMax = watch("amount_max");
  const amountIncrement = watch("amount_increment");
  const termMin = watch("term_min");
  const termMax = watch("term_max");
  const termIncrement = watch("term_increment");
  const prepaymentPenaltyMin = watch("prepaymentPenalty_min");
  const prepaymentPenaltyMax = watch("prepaymentPenalty_max");
  const prepaymentPenaltyIncrement = watch("prepaymentPenalty_increment");
  const rateMin = watch("rate_min");
  const rateMax = watch("rate_max");
  const rateIncrement = watch("rate_increment");
  const paymentFrequencyPermitted = watch("payment_frequency_permitted") || [];
  React.useEffect(() => {
    if (data) {
      // let sPaymentFrequencyPermitted = data?.sPaymentFrequencyPermitted;
      // //  = sPaymentFrequencyPermitted? 用逗号拆分成数组
      // let payFrequencyPermittedArr = sPaymentFrequencyPermitted.split(",");
      // let latefee_custom = data?.latefee?.latefee_custom;
      // reset({
      //   sApplicantEnterLoanAmount: data?.sApplicantEnterLoanAmount || "NO",
      //   sApplicantChooseLoanTerm: data?.sApplicantChooseLoanTerm || "NO",
      //   sApplicantChoosePaymentFrequency:
      //     data?.sApplicantChoosePaymentFrequency || "NO",
      //   amount_min: data?.amount?.amount_min || 0,
      //   amount_max: data?.amount?.amount_max || 0,
      //   amount_increment: data?.amount?.amount_increment || 0,
      //   matchedSavingsoffer:
      //     data?.matchMaxAmount?.max_match_amount > 0 ? "YES" : "NO",
      //   max_match_amount: data?.matchMaxAmount?.max_match_amount || "",
      //   term_min: data?.term?.term_min || 0,
      //   term_max: data?.term?.term_max || 0,
      //   term_increment: data?.term?.term_increment || 0,
      //   prepaymentPenalty_min:
      //     data?.prepaymentPenalty?.prepaymentPenalty_min || 0.0,
      //   prepaymentPenalty_max:
      //     data?.prepaymentPenalty?.prepaymentPenalty_max || 0.0,
      //   prepaymentPenalty_increment:
      //     data?.prepaymentPenalty?.prepaymentPenalty_increment || 0.0,
      //   rate_min: data?.rate?.rate_min || 0.0,
      //   rate_max: data?.rate?.rate_max || 0.0,
      //   rate_increment: data?.rate?.rate_increment || 0.0,
      //   pledged_min: data?.pledged?.pledged_min || 0.0,
      //   pledged_max: data?.pledged?.pledged_max || 0.0,
      //   pledged_increment: data?.pledged?.pledged_increment || 0.0,
      //   purchases_rate: data?.purchases_rate || 0.0,
      //   balance_transfer_rate: data?.balance_transfer_rate || 0.0,
      //   cash_advance_rate: data?.cash_advance_rate || 0.0,
      //   penalty_rate: data?.penalty_rate || 0.0,
      //   allowZerorate: data?.rate?.allowZerorate || "",
      //   payment_frequency_permitted: payFrequencyPermittedArr || [],
      //   graceperiod_adjust: data?.gracePeriod?.graceperiod_adjust || "",
      //   latefee_adjust: data?.latefee?.latefee_adjust || "",
      //   latefee_adjust_custom: data?.latefee?.latefee_adjust_custom || "",
      //   // latefee_custom: data?.latefee?.latefee_custom || "",
      //   latefee_paymentfrequency_M11: latefee_custom?.M11 || "",
      //   latefee_paymentfrequency_M12: latefee_custom?.M12 || "",
      //   latefee_paymentfrequency_M13: latefee_custom?.M13 || "",
      //   latefee_paymentfrequency_W11: latefee_custom?.W11 || "",
      //   latefee_paymentfrequency_W21: latefee_custom?.W21 || "",
      //   latefee_paymentfrequency_ONCE: latefee_custom?.ONCE || "",
      //   latefee_max: data?.latefee?.latefee_max || "",
      //   latefee_min: data?.latefee?.latefee_min || "",
      //   latefee_increment: data?.latefee?.latefee_increment || "",
      //   latefee_unit: data?.latefee?.latefee_unit || "Amount",
      //   interest_rate_type: data?.spreadRate?.sInterestRateType || "",
      //   baserate: data?.spreadRate?.dBaseRate || "",
      //   useMarketRate: data?.spreadRate?.sUseMarketRate || "NO",
      // });

      const newValues = buildInitialValues();
      reset(newValues, {
        keepDirty: false,
        keepValues: false,
      });
      if (data?.matchMaxAmount?.max_match_amount > 0) {
        setShowMatchingAmount(true);
      } else {
        setShowMatchingAmount(false);
      }

      if (data?.latefee?.latefee_adjust == "Yes") {
        setShowLateFeeSetting(true);
      }

      if (data?.gracePeriod?.graceperiod_adjust == "Yes") {
        setShowGracePeriodSetting(true);
      }
      if (data?.gracePeriod?.graceperiod_adjust == "No") {
        setShowGracePeriodCustom(true);
      }

      setInterestRateType(data?.spreadRate?.sInterestRateType);
      //stepRateData 如果没有值，则默认需要展示一组空白的

      // if (
      //   !data?.spreadRate?.steppedSpread ||
      //   data?.spreadRate?.steppedSpread.length == 0
      // ) {
      //   console.log("steppedSpread 没有数据===>");
      //   setStepRateGroup([{ rate: "", month: "" }]);
      // } else {
      //   data?.spreadRate?.steppedSpread?.forEach((item: any, index: number) => {
      //     //如果是最后一行， 则month为remaining，rate_lastone为最后一个
      //     if (index == data?.spreadRate?.steppedSpread.length - 1) {
      //       setValue("step_rate_month_lastone", item.iRateMonths);
      //       setValue("step_rate_rate_lastone", item.dBaseRate);
      //     } else {
      //       console.log("steppedSpread 22233344===>", item);
      //       setStepRateGroup((prev) => [
      //         ...prev,
      //         { rate: item.dBaseRate, month: item.iRateMonths },
      //       ]);
      //       setValue(`step_rate_rate_${index}`, item.dBaseRate);
      //       setValue(`step_rate_month_${index}`, item.iRateMonths);
      //     }
      //   });
      // }

      if (
        !data?.spreadRate?.steppedSpread ||
        data?.spreadRate?.steppedSpread.length == 0
      ) {
        setStepRateGroup([]); // 改为空数组而不是默认空白项
      } else {
        const newGroups: { rate: string; month: string }[] = [];
        data?.spreadRate?.steppedSpread?.forEach((item: any, index: number) => {
          if (index < data?.spreadRate?.steppedSpread.length - 1) {
            newGroups.push({ rate: item.dBaseRate, month: item.iRateMonths });
            setValue(`step_rate_rate_${index}`, item.dBaseRate);
            setValue(`step_rate_month_${index}`, item.iRateMonths);
          } else {
            setValue("step_rate_month_lastone", item.iRateMonths);
            setValue("step_rate_rate_lastone", item.dBaseRate);
          }
        });
        setStepRateGroup(newGroups);
      }

      // console.log("===>", stepRateGroup);
      if (data?.spreadRate?.sCreditSpreadList) {
        const newGroups2: { title: string; rate: string }[] = [];
        data?.spreadRate?.sCreditSpreadList?.forEach(
          (item: any, index: number) => {
            newGroups2.push({ title: item.desc, rate: item.rate });
            setValue(`credit_spread_desc_${index}`, item.rate);
            setValue(`credit_spread_rate_${index}`, item.desc);
          }
        );
        setGroups(newGroups2);
      }
      if (data?.spreadRate?.sTechnicalSpreadList) {
        const newGroups3: { title: string; rate: string }[] = [];
        data?.spreadRate?.sTechnicalSpreadList?.forEach(
          (item: any, index: number) => {
            newGroups3.push({ title: item.desc, rate: item.rate });
            setValue(`technical_spread_desc_${index}`, item.rate);
            setValue(`technical_spread_rate_${index}`, item.desc);
          }
        );
        setGroupsTechnical(newGroups3);
      }
      if (data?.spreadRate?.sDiscountSpreadList) {
        const newGroups4: { title: string; rate: string }[] = [];
        data?.spreadRate?.sDiscountSpreadList?.forEach(
          (item: any, index: number) => {
            newGroups4.push({ title: item.desc, rate: item.rate });
            setValue(`interest_spread_desc_${index}`, item.rate);
            setValue(`interest_spread_rate_${index}`, item.desc);
          }
        );
        setGroupsDiscount(newGroups4);
      }
    }
  }, [data, reset]);

  React.useEffect(() => {
    // console.log("Terms isDirty changed====>:", isDirty);
    if (props?.onDirtyChange) {
      props?.onDirtyChange(props?.curMenu, isDirty);
    }
  }, [isDirty, reset]);

  const handleSaveClick = () => {
    const formData = getValues();
    formData.saveAction = "terms";
    formData.loan_type = selectedLoanType;
    formData.loan_amortization = selectedAmortization;
    let selectASIds: any[] = [];
    //accountserviceOptions, 匹配这里面的id
    selectedAccountService.forEach((item: string) => {
      const found = accountserviceOptions.find(
        (option: any) => option.id === item
      );
      if (found) {
        selectASIds.push(found.value);
      }
    });
    // formData.account_services_offered = selectedAccountService;
    formData.account_services_offered = selectASIds.join(",");
    // console.log(
    //   "formData.account_services_offered====>",
    //   formData.account_services_offered
    // );
    //change

    if (
      productModulesGroup?.includes("term_amount_step") ||
      subType == "buildingladder"
    ) {
      let amount_min_arr: any[] = [];
      let amount_max_arr: any[] = [];
      let amount_step_arr: any[] = [];
      let term_min_arr: any[] = [];
      let term_max_arr: any[] = [];
      let term_step_arr: any[] = [];
      Object.keys(formData).forEach((key) => {
        if (key.startsWith("amount_min_")) {
          amount_min_arr.push(formData[key]);
        }
        if (key.startsWith("amount_max_")) {
          amount_max_arr.push(formData[key]);
        }
        if (key.startsWith("amount_increment_")) {
          amount_step_arr.push(formData[key]);
        }
        if (key.startsWith("term_min_")) {
          term_min_arr.push(formData[key]);
        }
        if (key.startsWith("term_max_")) {
          term_max_arr.push(formData[key]);
        }
        if (key.startsWith("term_increment_")) {
          term_step_arr.push(formData[key]);
        }
      });
      formData["amount_min"] = amount_min_arr;
      formData["amount_max"] = amount_max_arr;
      formData["amount_increment"] = amount_step_arr;
      formData["term_min"] = term_min_arr;
      formData["term_max"] = term_max_arr;
      formData["term_increment"] = term_step_arr;
    }
    if (onSave) {
      onSave(formData, props?.curMenu);
      reset(formData); //保存后重置表单状态，isDirty 变为 false
    }
  };

  const hasAmountOrTermErrors =
    !!errors.amount_min ||
    !!errors.amount_max ||
    !!errors.amount_increment ||
    !!errors.term_min ||
    !!errors.term_max ||
    !!errors.term_increment;

  const lastAutoIncrementRef = React.useRef<Record<string, number>>({});

  const parseFieldNumber = (value: any) => {
    if (value === "" || value === null || value === undefined) {
      return null;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const isDivisibleRange = (range: number, increment: number) => {
    const quotient = range / increment;
    return Math.abs(quotient - Math.round(quotient)) < 1e-8;
  };

  const validateRangeField = ({
    value,
    minValue,
    maxValue,
    minAllowed,
    minLabel,
    maxLabel,
    incrementLabel,
    strictPositiveMin,
  }: {
    value: any;
    minValue: any;
    maxValue: any;
    minAllowed: number;
    minLabel: string;
    maxLabel: string;
    incrementLabel: string;
    strictPositiveMin: boolean;
  }) => {
    const min = parseFieldNumber(minValue);
    const max = parseFieldNumber(maxValue);
    const increment = parseFieldNumber(value);

    if (min !== null) {
      if (strictPositiveMin && min <= minAllowed) {
        return `${minLabel} must be greater than ${minAllowed}`;
      }
      if (!strictPositiveMin && min < minAllowed) {
        return `${minLabel} must be greater than or equal to ${minAllowed}`;
      }
    }

    if (max !== null) {
      if (strictPositiveMin && max <= minAllowed) {
        return `${maxLabel} must be greater than ${minAllowed}`;
      }
      if (!strictPositiveMin && max < minAllowed) {
        return `${maxLabel} must be greater than or equal to ${minAllowed}`;
      }
    }

    if (min !== null && max !== null && max < min) {
      return `${maxLabel} must be greater than or equal to ${minLabel}`;
    }

    if (increment === null) {
      return true;
    }

    if (increment < 0) {
      return `${incrementLabel} must be greater than or equal to 0`;
    }

    if (min === null || max === null) {
      return true;
    }

    const range = max - min;
    if (range === 0) {
      return increment === 0
        ? true
        : `${incrementLabel} must be 0 when ${minLabel} and ${maxLabel} are equal`;
    }

    if (increment === 0) {
      return `${incrementLabel} must be greater than 0 when ${maxLabel} is greater than ${minLabel}`;
    }

    return isDivisibleRange(range, increment)
      ? true
      : `${incrementLabel} must evenly divide the range between ${minLabel} and ${maxLabel}`;
  };

  const syncIncrementWithRange = React.useCallback(
    (
      minField: string,
      maxField: string,
      incrementField: string,
      minValue: any,
      maxValue: any,
      incrementValue: any
    ) => {
      const min = parseFieldNumber(minValue);
      const max = parseFieldNumber(maxValue);
      const increment = parseFieldNumber(incrementValue);

      if (min === null || max === null || max < min) {
        return;
      }

      const nextIncrement = max - min;
      const lastAutoIncrement = lastAutoIncrementRef.current[incrementField];
      const shouldAutoUpdate =
        increment === null ||
        increment === 0 ||
        increment === lastAutoIncrement;

      if (!shouldAutoUpdate) {
        return;
      }

      if (increment !== nextIncrement) {
        setValue(incrementField, nextIncrement, {
          shouldDirty: true,
          shouldValidate: true,
        });
      }

      lastAutoIncrementRef.current[incrementField] = nextIncrement;
    },
    [setValue]
  );

  React.useEffect(() => {
    syncIncrementWithRange(
      "amount_min",
      "amount_max",
      "amount_increment",
      amountMin,
      amountMax,
      amountIncrement
    );
  }, [amountMin, amountMax, amountIncrement, syncIncrementWithRange]);

  React.useEffect(() => {
    syncIncrementWithRange(
      "term_min",
      "term_max",
      "term_increment",
      termMin,
      termMax,
      termIncrement
    );
  }, [termMin, termMax, termIncrement, syncIncrementWithRange]);

  React.useEffect(() => {
    syncIncrementWithRange(
      "prepaymentPenalty_min",
      "prepaymentPenalty_max",
      "prepaymentPenalty_increment",
      prepaymentPenaltyMin,
      prepaymentPenaltyMax,
      prepaymentPenaltyIncrement
    );
  }, [
    prepaymentPenaltyMin,
    prepaymentPenaltyMax,
    prepaymentPenaltyIncrement,
    syncIncrementWithRange,
  ]);

  React.useEffect(() => {
    syncIncrementWithRange(
      "rate_min",
      "rate_max",
      "rate_increment",
      rateMin,
      rateMax,
      rateIncrement
    );
  }, [rateMin, rateMax, rateIncrement, syncIncrementWithRange]);

  //stepRate have rate, month two fileds

  const handleAddNewStepRateGroup = () => {
    setStepRateGroup([...stepRateGroup, { rate: "", month: "" }]);
  };
  const handleNewStepRateRemoveGroup = (index: number) => {
    if (stepRateGroup.length > 1) {
      const newGroups = [...stepRateGroup];
      newGroups.splice(index, 1);
      setStepRateGroup(newGroups);
    }
  };

  const handleAddNewCreditSpreadGroup = () => {
    setGroups([...groups, { title: "", rate: "" }]);
  };

  const handleNewCreditSpreadRemoveGroup = (index: number) => {
    if (groups.length > 1) {
      const newGroups = [...groups];
      newGroups.splice(index, 1);
      setGroups(newGroups);
    }
  };

  // const handleCreditSpreadChange = (index, field, value) => {
  //   const newGroups = [...groups];
  //   newGroups[index][field] = value;
  //   setGroups(newGroups);
  // };

  const handleAddNewTechnicalSpreadGroup = () => {
    setGroupsTechnical([...groupsTechnical, { title: "", rate: "" }]);
  };

  const handleNewTechnicalSpreadRemoveGroup = (index: number) => {
    if (groupsTechnical.length > 1) {
      const newGroups = [...groupsTechnical];
      newGroups.splice(index, 1);
      setGroupsTechnical(newGroups);
    }
  };
  const handleAddNewDiscountSpreadGroup = () => {
    setGroupsDiscount([...groupsDiscount, { title: "", rate: "" }]);
  };

  const handleNewDiscountSpreadRemoveGroup = (index: number) => {
    if (groupsDiscount.length > 1) {
      const newGroups = [...groupsDiscount];
      newGroups.splice(index, 1);
      setGroupsDiscount(newGroups);
    }
  };
  const getAlphabetLabel = (index: number) => {
    return String.fromCharCode(65 + index); // 65 is ASCII for 'A'
  };

  const handleChangeLoanType = (selectedItemStr: any) => {
    setSelectedLoanType(
      selectedItemStr.split(",").map((item: string) => item.trim())
    );
    setShowSubmitButton(true);
  };

  const handleChangeAmortization = (selectedItemStr: any) => {
    setSelectedAmortization(
      selectedItemStr.split(",").map((item: string) => item.trim())
    );
    setShowSubmitButton(true);
  };
  const handleChangeAccountService = (selectedItemStr: any) => {
    //如果选中checking-account, 则checking-debit-card, checking-check-order, checking-overdraft-protection 都需要选中
    // if (selectedItemStr.includes("checking-account")) {
    //   selectedItemStr = selectedItemStr
    //     .split(",")
    //     .map((item: string) => item.trim())
    //     .concat([
    //       "checking-debit-card",
    //       "checking-check-order",
    //       "checking-overdraft-protection",
    //     ]);
    // }
    setSelectAccountService(
      selectedItemStr.split(",").map((item: string) => item.trim())
    );
    // alert(selectedItemStr);
    setShowSubmitButton(true);
  };

  //未完成
  const AddStemTermData = () => {
    let newItem = {
      minTerms: "",
      maxTerms: "",
      stepTerms: "",
      minAmount: "",
      maxAmount: "",
      stepAmount: "",
    };
    // setStepTermsData([...stepTermsData, newItem]);
  };
  //未完成
  const RemoveStepTermData = (index: number) => {
    // setStepTermsData(stepTermsData.filter((_, i) => i !== index));
  };
  // console.log("stepRateGroup=====>", stepRateGroup);
  return (
    <SectionStyled id="reqBox_terms">
      <SectionTitle title="Terms - Define product or service terms and limits" />
      <Box
        sx={{
          padding: "10px",
          height: "calc(100vh - 255px)",
          overflowY: "auto",
          // background: "yellow",
        }}
      >
        {productModulesGroup?.includes("applicant_setting") && (
          <Grid container>
            {/* Applicant will NOT enter loan amount */}
            <Grid item xs={12}>
              <Controller
                name="sApplicantEnterLoanAmount"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value === "NO"}
                        color="primary"
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "NO" : "YES");
                        }}
                      />
                    }
                    label={"Applicant will NOT enter loan amount"}
                  />
                )}
              />
            </Grid>
            {/* Applicant will NOT choose loan term */}
            <Grid item xs={12}>
              <Controller
                name="sApplicantChooseLoanTerm"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value === "NO"}
                        color="primary"
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "NO" : "YES");
                        }}
                      />
                    }
                    label={"Applicant will NOT choose loan term"}
                  />
                )}
              />
            </Grid>
            {/* Applicant will NOT choose payment frequency */}
            <Grid item xs={12}>
              <Controller
                name="sApplicantChoosePaymentFrequency"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value === "NO"}
                        color="primary"
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "NO" : "YES");
                        }}
                      />
                    }
                    label={"Applicant will NOT choose payment frequency"}
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
        {subType != "account" && (
          <Grid container spacing={1}>
            <Grid item xs={2}></Grid>
            <Grid item xs={1}>
              Mininum
            </Grid>
            <Grid item xs={1}>
              Maxinum
            </Grid>
            <Grid item xs={1}>
              Increment
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        )}
        {/* Amount */}
        {(productModulesGroup?.includes("amount") ||
          productModulesGroup?.includes("credit_limit")) && (
          <Grid container spacing={1}>
            <Grid item xs={2}>
              {subType == "securedcreditcard" ? (
                <FieldTitle title="Credit limit ($)" />
              ) : (
                <FieldTitle title="Amount ($)" />
              )}
            </Grid>
            <Grid item xs={1}>
              <Controller
                name="amount_min"
                control={control}
                //>0
                rules={{
                  required: "Minimum amount is required", // 添加必填验证
                  validate: (value) => {
                    const maxValue = getValues("amount_max");
                    return validateRangeField({
                      value: getValues("amount_increment"),
                      minValue: value,
                      maxValue: parseFieldNumber(maxValue) === 0 ? null : maxValue,
                      minAllowed: 0,
                      minLabel: "Min amount",
                      maxLabel: "Max amount",
                      incrementLabel: "Increment",
                      strictPositiveMin: true,
                    });
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <CustomProductIntTextField
                    {...field}
                    helperText={error?.message}
                    onChange={(eValue) => {
                      const value = eValue.toString();
                      field.onChange(value === "" ? "" : parseFloat(value));
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={1}>
              <Controller
                name="amount_max"
                control={control}
                rules={{
                  required: "Maximum amount is required", // 添加必填验证
                  validate: (value) => {
                    return validateRangeField({
                      value: getValues("amount_increment"),
                      minValue: getValues("amount_min"),
                      maxValue: value,
                      minAllowed: 0,
                      minLabel: "Min amount",
                      maxLabel: "Max amount",
                      incrementLabel: "Increment",
                      strictPositiveMin: true,
                    });
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <CustomProductIntTextField
                    {...field}
                    error={!!error}
                    helperText={error?.message}
                    onChange={(eValue) => {
                      const value = eValue.toString();
                      field.onChange(value === "" ? "" : parseFloat(value));
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={1}>
              <Controller
                name="amount_increment"
                control={control}
                // 可以不填值，
                rules={{
                  validate: (value) => {
                    return validateRangeField({
                      value,
                      minValue: getValues("amount_min"),
                      maxValue: getValues("amount_max"),
                      minAllowed: 0,
                      minLabel: "Min amount",
                      maxLabel: "Max amount",
                      incrementLabel: "Increment",
                      strictPositiveMin: true,
                    });
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <CustomProductIntTextField
                    {...field}
                    error={!!error}
                    helperText={error?.message}
                    onChange={(eValue) => {
                      const value = eValue.toString();
                      field.onChange(value === "" ? "" : parseFloat(value));
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <Controller
                name="matchedSavingsoffer"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...field}
                        checked={field.value === "YES"}
                        color="primary"
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "YES" : "NO");
                          setShowMatchingAmount(e.target.checked);
                        }}
                      />
                    }
                    label={"Matched Savings Offer"}
                  />
                )}
              />
            </Grid>
            {showMatchingAmount ? (
              <>
                <Grid item xs={3}>
                  Maximum Matching Amount ($)
                </Grid>
                <Grid item xs={1}>
                  <Controller
                    name="max_match_amount"
                    control={control}
                    //must > 0
                    rules={{
                      validate: (value) => {
                        if (value === "") return true; // 允许空值
                        return (
                          parseFloat(value) > 0 ||
                          "Max matching amount must be greater than 0"
                        );
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <CustomProductIntTextField
                        {...field}
                        error={!!error}
                        helperText={error?.message}
                        onChange={(eValue) => {
                          const value = eValue.toString();
                          field.onChange(value === "" ? "" : parseFloat(value));
                        }}
                      />
                    )}
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}></Grid>
              </>
            )}
          </Grid>
        )}
        {/* Depository Account Balance Pledged (%)	，pledged_min,pledged_max,pledged_increment */}
        {productModulesGroup?.includes("deposit_pledge") &&
          subType == "securedcreditcard" && (
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <FieldTitle title="Depository Account Balance Pledged (%)" />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="pledged_min"
                  control={control}
                  rules={{
                    validate: (value) => {
                      if (value === "") return true; // 允许空值
                      return (
                        parseFloat(value) > 0 ||
                        "Min pledged amount must be greater than 0"
                      );
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="pledged_max"
                  control={control}
                  rules={{
                    validate: (value) => {
                      const pledgedMin = getValues("pledged_min");
                      if (value === "" || pledgedMin === "") return true; // 允许空值
                      return (
                        parseFloat(value) >= parseFloat(pledgedMin) ||
                        "Max pledged amount must be greater than Min pledged amount"
                      );
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="pledged_increment"
                  control={control}
                  rules={{
                    validate: (value) => {
                      const pledgedMin = getValues("pledged_min");
                      const pledgedMax = getValues("pledged_max");
                      if (value === "" || value == 0) return true;
                      const min = parseFloat(pledgedMin);
                      const max = parseFloat(pledgedMax);
                      const increment = parseFloat(value);
                      const range = max - min;
                      if (range == 0 && increment > 0) {
                        return "Increment must be 0 when min and max are equal";
                      }

                      console.log("step2======>", value);
                      if (value > 0) {
                        // Check if increment is a divisor of the range
                        if (range % increment === 0) {
                          return true;
                        } else {
                          return "Increment must be a divisor of the range";
                        }

                        return true;
                      } else {
                        return "Increment must be greater than 0";
                      }
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          )}
        {productModulesGroup?.includes("credit_apr") &&
          subType == "securedcreditcard" && (
            <>
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <FieldTitle title="Interest Rates (APR)" />
                </Grid>
                <Grid item xs={10}></Grid>
              </Grid>
              {/* Purchases (%) */}
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <FieldTitle title="Purchases (%)" />
                </Grid>
                <Grid item xs={1}>
                  <Controller
                    name="purchases_rate"
                    control={control}
                    rules={{
                      validate: (value) => {
                        if (value === "") return true; // 允许空值
                        return (
                          parseFloat(value) > 0 ||
                          "Purchases rate must be greater than 0"
                        );
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <CustomProductNumberTextField
                        {...field}
                        error={!!error}
                        helperText={error?.message}
                        onChange={(eValue) => {
                          const value = eValue.toString();
                          field.onChange(value === "" ? "" : parseFloat(value));
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={9}></Grid>
              </Grid>
              {/* Balance Transfer (%) */}
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <FieldTitle title="Balance Transfer (%)" />
                </Grid>
                <Grid item xs={1}>
                  <Controller
                    name="balance_transfer_rate"
                    control={control}
                    rules={{
                      validate: (value) => {
                        if (value === "") return true; // 允许空值
                        return (
                          parseFloat(value) > 0 ||
                          "Balance transfer rate must be greater than 0"
                        );
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <CustomProductNumberTextField
                        {...field}
                        error={!!error}
                        helperText={error?.message}
                        onChange={(eValue) => {
                          const value = eValue.toString();
                          field.onChange(value === "" ? "" : parseFloat(value));
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={9}></Grid>
              </Grid>
              {/* Cash Advance (%) */}
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <FieldTitle title="Cash Advance (%)" />
                </Grid>
                <Grid item xs={1}>
                  <Controller
                    name="cash_advance_rate"
                    control={control}
                    rules={{
                      validate: (value) => {
                        if (value === "") return true; // 允许空值
                        return (
                          parseFloat(value) > 0 ||
                          "Cash advance rate must be greater than 0"
                        );
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <CustomProductNumberTextField
                        {...field}
                        error={!!error}
                        helperText={error?.message}
                        onChange={(eValue) => {
                          const value = eValue.toString();
                          field.onChange(value === "" ? "" : parseFloat(value));
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={9}></Grid>
              </Grid>
              {/* Penalty Rate (%) */}
              <Grid container spacing={1}>
                <Grid item xs={2}>
                  <FieldTitle title="Penalty Rate (%)" />
                </Grid>
                <Grid item xs={1}>
                  <Controller
                    name="penalty_rate"
                    control={control}
                    rules={{
                      validate: (value) => {
                        if (value === "") return true; // 允许空值
                        return (
                          parseFloat(value) > 0 ||
                          "Penalty rate must be greater than 0"
                        );
                      },
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <CustomProductNumberTextField
                        {...field}
                        error={!!error}
                        helperText={error?.message}
                        onChange={(eValue) => {
                          const value = eValue.toString();
                          field.onChange(value === "" ? "" : parseFloat(value));
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={9}></Grid>
              </Grid>
            </>
          )}
        {/* ************ */}
        {/* Term (Months) */}
        {productModulesGroup?.includes("term") &&
          subType != "securedcreditcard" && (
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <FieldTitle title="Term (Months)" />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="term_min"
                  control={control}
                  rules={{
                    required: "Minimum term is required", // 添加必填验证
                    validate: (value) => {
                      const maxValue = getValues("term_max");
                      return validateRangeField({
                        value: getValues("term_increment"),
                        minValue: value,
                        maxValue: parseFieldNumber(maxValue) === 0 ? null : maxValue,
                        minAllowed: 0,
                        minLabel: "Min term",
                        maxLabel: "Max term",
                        incrementLabel: "Increment",
                        strictPositiveMin: true,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductIntTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="term_max"
                  control={control}
                  rules={{
                    validate: (value) => {
                      return validateRangeField({
                        value: getValues("term_increment"),
                        minValue: getValues("term_min"),
                        maxValue: value,
                        minAllowed: 0,
                        minLabel: "Min term",
                        maxLabel: "Max term",
                        incrementLabel: "Increment",
                        strictPositiveMin: true,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductIntTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="term_increment"
                  control={control}
                  rules={{
                    validate: (value) => {
                      return validateRangeField({
                        value,
                        minValue: getValues("term_min"),
                        maxValue: getValues("term_max"),
                        minAllowed: 0,
                        minLabel: "Min term",
                        maxLabel: "Max term",
                        incrementLabel: "Increment",
                        strictPositiveMin: true,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductIntTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          )}
        {/* term_amount_step */}
        {productModulesGroup?.includes("term_amount_step") && (
          <>
            {data?.stepTermsData?.map((item: any, index: number) => (
              <>
                <Grid container spacing={1} sx={{}}>
                  {/* <Grid item xs={1}>
                    <FieldTitle title={"Step"} />
                  </Grid> */}
                  <Grid item xs={2}>
                    <FieldTitle title={"Amount ($)"} />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name={`amount_min_${index}`}
                      control={control}
                      defaultValue={item?.minAmount}
                      render={({ field }) => (
                        <CustomProductNumberTextField {...field} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name={`amount_max_${index}`}
                      control={control}
                      defaultValue={item?.maxAmount}
                      render={({ field }) => (
                        <CustomProductIntTextField {...field} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name={`amount_increment_${index}`}
                      control={control}
                      defaultValue={item?.stepAmount}
                      render={({ field }) => (
                        <CustomProductIntTextField {...field} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={7}></Grid>
                </Grid>
                <Grid container spacing={1} sx={{ mb: 2 }}>
                  {/* <Grid item xs={1}></Grid> */}
                  <Grid item xs={2}>
                    <FieldTitle title={"Term (Months)"} />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name={`term_min_${index}`}
                      control={control}
                      defaultValue={item?.minTerms}
                      render={({ field }) => (
                        <CustomProductNumberTextField {...field} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name={`term_max_${index}`}
                      control={control}
                      defaultValue={item?.maxTerms}
                      render={({ field }) => (
                        <CustomProductIntTextField {...field} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Controller
                      name={`term_increment_${index}`}
                      control={control}
                      defaultValue={item?.stepTerms}
                      render={({ field }) => (
                        <CustomProductIntTextField {...field} />
                      )}
                    />
                  </Grid>
                  <Grid item xs={7}>
                    <IconButton>
                      <img
                        src="/public/icon/action-delete.png"
                        style={{
                          width: "18px",
                          height: "18px",
                          cursor: "pointer",
                        }}
                        onClick={() => RemoveStepTermData(index)}
                      />
                    </IconButton>
                  </Grid>
                </Grid>
              </>
            ))}
            <Button variant="outlined" onClick={AddStemTermData}>
              Add More Step
            </Button>
          </>
        )}

        {/* Prepayment Penalty (%)	prepaymentPenalty */}
        {productModulesGroup?.includes("prepay_penalty") &&
          subType != "securedcreditcard" && (
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <FieldTitle title="Prepayment Penalty (%)" />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="prepaymentPenalty_min"
                  control={control}
                  rules={{
                    validate: (value) => {
                      const maxValue = getValues("prepaymentPenalty_max");
                      return validateRangeField({
                        value: getValues("prepaymentPenalty_increment"),
                        minValue: value,
                        maxValue: parseFieldNumber(maxValue) === 0 ? null : maxValue,
                        minAllowed: 0,
                        minLabel: "Min prepayment penalty",
                        maxLabel: "Max prepayment penalty",
                        incrementLabel: "Increment",
                        strictPositiveMin: false,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="prepaymentPenalty_max"
                  control={control}
                  rules={{
                    validate: (value) => {
                      return validateRangeField({
                        value: getValues("prepaymentPenalty_increment"),
                        minValue: getValues("prepaymentPenalty_min"),
                        maxValue: value,
                        minAllowed: 0,
                        minLabel: "Min prepayment penalty",
                        maxLabel: "Max prepayment penalty",
                        incrementLabel: "Increment",
                        strictPositiveMin: false,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="prepaymentPenalty_increment"
                  control={control}
                  rules={{
                    validate: (value) => {
                      return validateRangeField({
                        value,
                        minValue: getValues("prepaymentPenalty_min"),
                        maxValue: getValues("prepaymentPenalty_max"),
                        minAllowed: 0,
                        minLabel: "Min prepayment penalty",
                        maxLabel: "Max prepayment penalty",
                        incrementLabel: "Increment",
                        strictPositiveMin: false,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          )}
        {/* Interest Rate (%) rate_min,rate_max ... */}
        {productModulesGroup?.includes("interest_rate") &&
          subType != "securedcreditcard" && (
            <Grid container spacing={1}>
              <Grid item xs={2}>
                <FieldTitle title="Interest Rate (%)" />
                {productModulesGroup?.includes("interest_more") && (
                  <Link
                    to="#"
                    style={{ color: "#00CCB1", fontSize: "14px" }}
                    onClick={() =>
                      setShowMoreRateSettings(!showMoreRateSettings)
                    }
                  >
                    {!showMoreRateSettings && (
                      <ExpandMoreIcon sx={{ fontSize: "14px" }} />
                    )}
                    {showMoreRateSettings && (
                      <ExpandLessIcon sx={{ fontSize: "14px" }} />
                    )}
                    More Settings
                  </Link>
                )}
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="rate_min"
                  control={control}
                  rules={{
                    validate: (value) => {
                      const maxValue = getValues("rate_max");
                      return validateRangeField({
                        value: getValues("rate_increment"),
                        minValue: value,
                        maxValue: parseFieldNumber(maxValue) === 0 ? null : maxValue,
                        minAllowed: 0,
                        minLabel: "Min rate",
                        maxLabel: "Max rate",
                        incrementLabel: "Increment",
                        strictPositiveMin: false,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="rate_max"
                  control={control}
                  rules={{
                    validate: (value) => {
                      return validateRangeField({
                        value: getValues("rate_increment"),
                        minValue: getValues("rate_min"),
                        maxValue: value,
                        minAllowed: 0,
                        minLabel: "Min rate",
                        maxLabel: "Max rate",
                        incrementLabel: "Increment",
                        strictPositiveMin: false,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={1}>
                <Controller
                  name="rate_increment"
                  control={control}
                  rules={{
                    validate: (value) => {
                      return validateRangeField({
                        value,
                        minValue: getValues("rate_min"),
                        maxValue: getValues("rate_max"),
                        minAllowed: 0,
                        minLabel: "Min rate",
                        maxLabel: "Max rate",
                        incrementLabel: "Increment",
                        strictPositiveMin: false,
                      });
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField
                      {...field}
                      error={!!error}
                      helperText={error?.message}
                      onChange={(eValue) => {
                        const value = eValue.toString();
                        field.onChange(value === "" ? "" : parseFloat(value));
                      }}
                      sx={{ marginTop: "12px" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Controller
                  name="allowZerorate"
                  control={control}
                  render={({ field }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          checked={field.value === "Yes"}
                          color="primary"
                          onChange={(e) => {
                            field.onChange(e.target.checked ? "Yes" : "No");
                          }}
                          sx={{
                            paddingTop: "20px",
                          }}
                        />
                      }
                      label={"Allow 0% Interest Rate"}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}></Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          )}
        {/* more rate settings  */}
        {/* Interest Rate Type */}
        {productModulesGroup?.includes("interest_more") &&
          subType != "securedcreditcard" && (
            <>
              {showMoreRateSettings && (
                <Box>
                  <Grid container spacing={1}>
                    <Grid item xs={2}>
                      <FieldTitle title="Interest Rate Type" />
                    </Grid>
                    <Grid item xs={2}>
                      <Controller
                        name="interest_rate_type"
                        control={control}
                        render={({ field }) => (
                          <CustomProductSelect
                            {...field}
                            fullWidth
                            variant="outlined"
                            optionlist={[
                              { value: "", label: "Select" },
                              { value: "Fixed", label: "Fixed with Spread" },
                              { value: "Stepped", label: "Stepped" },
                              { value: "Variable", label: "Variable" },
                            ]}
                            onChange={(e) => {
                              field.onChange(e);
                              setInterestRateType(e.target.value.toString());
                            }}
                          />
                        )}
                      />
                    </Grid>
                    {interestratetype == "Fixed" && (
                      <>
                        <Grid item xs={1}>
                          <FieldTitle title="Base Rate (%)" />
                        </Grid>
                        <Grid item xs={3}>
                          <Controller
                            name="baserate"
                            control={control}
                            render={({ field }) => (
                              <CustomProductNumberTextField small {...field} />
                            )}
                          />
                        </Grid>
                      </>
                    )}
                    {interestratetype == "Variable" && (
                      <>
                        <Grid item xs={4}>
                          <Controller
                            name="useMarketRate"
                            control={control}
                            render={({ field }) => (
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    {...field}
                                    checked={field.value === "YES"}
                                    color="primary"
                                    onChange={(e) => {
                                      field.onChange(
                                        e.target.checked ? "YES" : "NO"
                                      );
                                    }}
                                  />
                                }
                                label={"Use market interest rate benchmark"}
                              />
                            )}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item xs={3}></Grid>
                    <Grid item xs={1}></Grid>
                  </Grid>
                  {interestratetype == "Stepped" && (
                    <>
                      {stepRateGroup?.map((group, index) => (
                        <>
                          <Grid container spacing={1} sx={{ mt: 2 }}>
                            <Grid item xs={2}>
                              <FieldTitle
                                title={"Base Rate (%)"}
                                align="right"
                              />
                            </Grid>
                            <Grid item xs={1}>
                              <Controller
                                name={`step_rate_rate_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductNumberTextField {...field} />
                                )}
                              />
                            </Grid>
                            <Grid item xs={1}>
                              <Controller
                                name={`step_rate_month_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductIntTextField {...field} />
                                )}
                              />
                            </Grid>
                            <Grid item xs={4} sx={{ ml: 1 }}>
                              <FieldTitle title={"Months"} />
                            </Grid>
                          </Grid>
                        </>
                      ))}
                      <Grid container spacing={1} sx={{ mt: 2 }}>
                        <Grid item xs={2}>
                          <FieldTitle title={"Base Rate (%)"} align="right" />
                        </Grid>
                        <Grid item xs={1}>
                          <Controller
                            name={`step_rate_rate_lastone`}
                            control={control}
                            render={({ field }) => (
                              <CustomProductNumberTextField {...field} />
                            )}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={1}
                          sx={{ "& .MuiTextField-root": { marginTop: 0 } }}
                        >
                          <Controller
                            name={`step_rate_month_lastone`}
                            defaultValue={"remaining"}
                            control={control}
                            render={({ field }) => (
                              <CustomProductTextField
                                readOnly={true}
                                {...field}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={1} sx={{ ml: 1 }}>
                          <FieldTitle title={" Months"} />
                        </Grid>
                        <Grid item xs={3}>
                          <IconButton
                            onClick={handleAddNewStepRateGroup}
                            color="primary"
                            size="small"
                            sx={{ ml: 1 }}
                          >
                            <AddIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </>
                  )}

                  {/* Interest Rate Spread Levels
                   */}
                  <Box>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <FieldTitle title="Interest Rate Spread Levels " />
                      </Grid>
                    </Grid>
                    <Box id="creditSpreadSection">
                      <Grid container spacing={1}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={3}>
                          <FieldTitle title="Credit Spread (bps)" />
                        </Grid>
                        <Grid item xs={3}>
                          <FieldTitle title="Incremental Spread (%)	" />
                        </Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                      {groups?.map((group, index) => (
                        <>
                          <Grid
                            container
                            spacing={1}
                            key={index}
                            sx={{ mb: 1 }}
                          >
                            <Grid item xs={2}>
                              <FieldTitle
                                title={getAlphabetLabel(index)}
                                align="right"
                              />
                            </Grid>
                            <Grid
                              item
                              xs={3}
                              sx={{ "& .MuiTextField-root": { marginTop: 0 } }}
                            >
                              <Controller
                                name={`credit_spread_desc_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductTextField {...field} />
                                )}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <Controller
                                name={`credit_spread_rate_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductNumberTextField
                                    {...field}
                                    small
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <IconButton
                                onClick={() =>
                                  handleNewCreditSpreadRemoveGroup(index)
                                }
                                color="error"
                                size="small"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </>
                      ))}
                      <Grid container spacing={1}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={3}>
                          <Button
                            variant="outlined"
                            onClick={handleAddNewCreditSpreadGroup}
                            fullWidth
                            sx={{
                              mt: 1,
                              width: "250px",
                              textTransform: "none",
                            }}
                          >
                            Add Credit Spread by Type
                          </Button>
                        </Grid>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </Box>
                    <Box id="technicalSpreadSection">
                      <Grid container spacing={1}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={3}>
                          <FieldTitle title="Technical Spread (bps)" />
                        </Grid>
                        <Grid item xs={3}>
                          <FieldTitle title="Incremental Spread (%)	" />
                        </Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                      {groupsTechnical?.map((group, index) => (
                        <>
                          <Grid
                            container
                            spacing={1}
                            key={index}
                            sx={{ mb: 1 }}
                          >
                            <Grid item xs={2}>
                              <FieldTitle
                                title={getAlphabetLabel(index)}
                                align="right"
                              />
                            </Grid>
                            <Grid
                              item
                              xs={3}
                              sx={{ "& .MuiTextField-root": { marginTop: 0 } }}
                            >
                              <Controller
                                name={`technical_spread_desc_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductTextField {...field} />
                                )}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <Controller
                                name={`technical_spread_rate_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductNumberTextField
                                    {...field}
                                    small
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <IconButton
                                onClick={() =>
                                  handleNewTechnicalSpreadRemoveGroup(index)
                                }
                                color="error"
                                size="small"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </>
                      ))}
                      <Grid container spacing={1}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={3}>
                          <Button
                            variant="outlined"
                            onClick={handleAddNewTechnicalSpreadGroup}
                            fullWidth
                            sx={{
                              mt: 1,
                              width: "250px",
                              textTransform: "none",
                            }}
                          >
                            Add Technical Spread by Type
                          </Button>
                        </Grid>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </Box>
                    <Box id="DiscountSpreadSection">
                      <Grid container spacing={1}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={3}>
                          <FieldTitle title="Interest Rate Discount" />
                        </Grid>
                        <Grid item xs={3}>
                          <FieldTitle title="Decremental Spread (%)" />
                        </Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                      {groupsDiscount?.map((group, index) => (
                        <>
                          <Grid
                            container
                            spacing={1}
                            key={index}
                            sx={{ mb: 1 }}
                          >
                            <Grid item xs={2}>
                              <FieldTitle
                                title={getAlphabetLabel(index)}
                                align="right"
                              />
                            </Grid>
                            <Grid
                              item
                              xs={3}
                              sx={{ "& .MuiTextField-root": { marginTop: 0 } }}
                            >
                              <Controller
                                name={`interest_spread_desc_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductTextField {...field} />
                                )}
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <Controller
                                name={`interest_spread_rate_${index}`}
                                control={control}
                                render={({ field }) => (
                                  <CustomProductNumberTextField
                                    {...field}
                                    small
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <IconButton
                                onClick={() =>
                                  handleNewDiscountSpreadRemoveGroup(index)
                                }
                                color="error"
                                size="small"
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </>
                      ))}
                      <Grid container spacing={1}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={3}>
                          <Button
                            variant="outlined"
                            onClick={handleAddNewDiscountSpreadGroup}
                            fullWidth
                            sx={{
                              mt: 1,
                              width: "250px",
                              textTransform: "none",
                            }}
                          >
                            Add Discount Spread by Type
                          </Button>
                        </Grid>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          )}
        {/* Payment Frequency */}
        {productModulesGroup?.includes("payment_cycle") &&
          subType != "securedcreditcard" && (
            <>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <FieldTitle title="Payment Frequency Permitted" />
                  {/* {paymentFrequencyPermitted.join(",")}------- */}
                </Grid>
                <Grid item xs={2}>
                  {/* Title : Grice Period (Days) */}
                  <FieldTitle title="Grace Period (Days)" />
                  {/* {showGracePeriodSetting ? "yes" : "no"} */}
                </Grid>
                <Grid item xs={3}>
                  <FieldTitle title="Late Payment Fee" />
                </Grid>
                <Grid item xs={1}>
                  {showLateFeeSetting && (
                    <Controller
                      name="latefee_max"
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <CustomProductNumberTextField
                          {...field}
                          error={!!error}
                          helperText={error?.message}
                        />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={1}>
                  {showLateFeeSetting && (
                    <Controller
                      name="latefee_unit"
                      control={control}
                      render={({ field }) => (
                        <CustomProductSelect
                          {...field}
                          fullWidth
                          variant="outlined"
                          optionlist={[
                            { value: "", label: "Select" },
                            { value: "Amount", label: "$" },
                            { value: "Percentage", label: "%" },
                          ]}
                        />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3}></Grid>
                <Grid item xs={2}>
                  {/* <Checkbox name="graceperiod_adjust" size="small" color="primary" /> */}
                  <Controller
                    name="graceperiod_adjust"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        size="small"
                        color="primary"
                        checked={field.value === "Yes"}
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "Yes" : "No");
                          setShowGracePeriodSetting(e.target.checked);
                          setShowGracePeriodCustom(!e.target.checked);
                        }}
                      />
                    )}
                  />
                  Default
                  {/* <Controller
                    name="graceperiod_adjust_custom"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        size="small"
                        color="primary"
                        checked={field.value === "YES"}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          field.onChange(isChecked ? "YES" : "NO");
                          setShowGracePeriodCustom(isChecked);
                          setValue(
                            "graceperiod_adjust",
                            isChecked ? "No" : getValues("graceperiod_adjust")
                          );
                          if (isChecked) {
                            setShowGracePeriodSetting(false);
                          } else {
                            setShowGracePeriodSetting(true);
                          }
                        }}
                      />
                    )}
                  />
                  Customized */}
                </Grid>
                <Grid item xs={3}>
                  <Controller
                    name="latefee_adjust"
                    control={control}
                    render={({ field }) => (
                      <Checkbox
                        {...field}
                        size="small"
                        color="primary"
                        checked={field.value === "Yes"}
                        onChange={(e) => {
                          field.onChange(e.target.checked ? "Yes" : "No");
                          setShowLateFeeSetting(e.target.checked);
                        }}
                      />
                    )}
                  />
                  Default
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              {/* Monthly Payment */}
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Controller
                    name="payment_frequency_permitted"
                    control={control}
                    render={({ field }) => {
                      const selectedValues = field.value || [];
                      return (
                        <Checkbox
                          checked={selectedValues.includes("M11")}
                          onChange={(e) => {
                            // const newValue = e.target.checked
                            //   ? [...selectedValues, "M11"]
                            //   : selectedValues.filter((v) => v !== "M11");
                            // field.onChange(newValue);
                            const newValue = e.target.checked
                              ? [...selectedValues, "M11"]
                              : selectedValues.filter(
                                  (v: string) => v !== "M11"
                                );
                            field.onChange(newValue);
                          }}
                          size="small"
                          color="primary"
                        />
                      );
                    }}
                  />
                  Monthly Payment
                </Grid>
                <Grid item xs={2}>
                  {showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("M11") && <>15 days</>}
                  {!showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("M11") &&
                    showGracePeriodCustom && (
                      <Controller
                        name="graceperiod_paymentfrequency_M11"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductIntTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={3}>
                  {showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("M11") &&
                    getValues("latefee_max") && (
                      <>
                        {getValues("latefee_unit") == "Amount" ? "$" : ""}
                        {getValues("latefee_max")}
                        {getValues("latefee_unit") == "Percentage" ? "%" : ""}
                      </>
                    )}
                  {!showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("M11") && (
                      <Controller
                        name="latefee_paymentfrequency_M11"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductNumberTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Controller
                    name="payment_frequency_permitted"
                    control={control}
                    render={({ field }) => {
                      const selectedValues = field.value || [];
                      return (
                        <Checkbox
                          checked={selectedValues.includes("M13")}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedValues, "M13"]
                              : selectedValues.filter(
                                  (v: string) => v !== "M13"
                                );
                            field.onChange(newValue);
                          }}
                          size="small"
                          color="primary"
                        />
                      );
                    }}
                  />
                  Month End Payment
                </Grid>
                <Grid item xs={2}>
                  {showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("M13") && <>15 days</>}
                  {!showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("M13") &&
                    showGracePeriodCustom && (
                      <Controller
                        name="graceperiod_paymentfrequency_M13"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductIntTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={3}>
                  {showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("M13") &&
                    getValues("latefee_max") && (
                      <>
                        {getValues("latefee_unit") == "Amount" ? "$" : ""}
                        {Number(getValues("latefee_max")).toFixed(2)}
                        {getValues("latefee_unit") == "Percentage" ? "%" : ""}
                      </>
                    )}
                  {!showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("M13") && (
                      <Controller
                        name="latefee_paymentfrequency_M13"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductNumberTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Controller
                    name="payment_frequency_permitted"
                    control={control}
                    render={({ field }) => {
                      const selectedValues = field.value || [];
                      return (
                        <Checkbox
                          checked={selectedValues.includes("M12")}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedValues, "M12"]
                              : selectedValues.filter(
                                  (v: string) => v !== "M12"
                                );
                            field.onChange(newValue);
                          }}
                          size="small"
                          color="primary"
                        />
                      );
                    }}
                  />
                  Semimonthly Payment
                </Grid>
                <Grid item xs={2}>
                  {showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("M12") && <>7 days</>}
                  {!showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("M12") &&
                    showGracePeriodCustom && (
                      <Controller
                        name="graceperiod_paymentfrequency_M12"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductIntTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={3}>
                  {showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("M12") &&
                    getValues("latefee_max") && (
                      <>
                        {getValues("latefee_unit") == "Amount" ? "$" : ""}
                        {Number(getValues("latefee_max") / 2).toFixed(2)}
                        {getValues("latefee_unit") == "Percentage" ? "%" : ""}
                      </>
                    )}
                  {!showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("M12") && (
                      <Controller
                        name="latefee_paymentfrequency_M12"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductNumberTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              {/* Biweekly Payment : W21*/}
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Controller
                    name="payment_frequency_permitted"
                    control={control}
                    render={({ field }) => {
                      const selectedValues = field.value || [];
                      return (
                        <Checkbox
                          checked={selectedValues.includes("W21")}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedValues, "W21"]
                              : selectedValues.filter(
                                  (v: string) => v !== "W21"
                                );
                            field.onChange(newValue);
                          }}
                          size="small"
                          color="primary"
                        />
                      );
                    }}
                  />
                  Biweekly Payment
                </Grid>
                <Grid item xs={2}>
                  {showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("W21") && <>7 days</>}
                  {!showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("W21") &&
                    showGracePeriodCustom && (
                      <Controller
                        name="graceperiod_paymentfrequency_W21"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductIntTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={3}>
                  {showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("W21") &&
                    getValues("latefee_max") && (
                      <>
                        {getValues("latefee_unit") == "Amount" ? "$" : ""}
                        {Number(getValues("latefee_max") / 2).toFixed(2)}
                        {getValues("latefee_unit") == "Percentage" ? "%" : ""}
                      </>
                    )}
                  {!showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("W21") && (
                      <Controller
                        name="latefee_paymentfrequency_W21"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductNumberTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Controller
                    name="payment_frequency_permitted"
                    control={control}
                    render={({ field }) => {
                      const selectedValues = field.value || [];
                      return (
                        <Checkbox
                          checked={selectedValues.includes("W11")}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedValues, "W11"]
                              : selectedValues.filter(
                                  (v: string) => v !== "W11"
                                );
                            field.onChange(newValue);
                          }}
                          size="small"
                          color="primary"
                        />
                      );
                    }}
                  />
                  Weekly Payment
                </Grid>
                <Grid item xs={2}>
                  {showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("W11") && <>5 days</>}
                  {!showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("W11") &&
                    showGracePeriodCustom && (
                      <Controller
                        name="graceperiod_paymentfrequency_W11"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductIntTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={3}>
                  {showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("W11") &&
                    getValues("latefee_max") && (
                      <>
                        {getValues("latefee_unit") == "Amount" ? "$" : ""}
                        {Number(getValues("latefee_max") / 4).toFixed(2)}
                        {getValues("latefee_unit") == "Percentage" ? "%" : ""}
                      </>
                    )}
                  {!showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("W11") && (
                      <Controller
                        name="latefee_paymentfrequency_W11"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductNumberTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={3}>
                  <Controller
                    name="payment_frequency_permitted"
                    control={control}
                    render={({ field }) => {
                      const selectedValues = field.value || [];
                      return (
                        <Checkbox
                          checked={selectedValues.includes("ONCE")}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedValues, "ONCE"]
                              : selectedValues.filter(
                                  (v: string) => v !== "ONCE"
                                );
                            field.onChange(newValue);
                          }}
                          size="small"
                          color="primary"
                        />
                      );
                    }}
                  />
                  Single Repayment
                </Grid>
                <Grid item xs={2}>
                  {showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("ONCE") && <>15 days</>}
                  {!showGracePeriodSetting &&
                    paymentFrequencyPermitted.includes("ONCE") &&
                    showGracePeriodCustom && (
                      <Controller
                        name="graceperiod_paymentfrequency_ONCE"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductIntTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={3}>
                  {showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("ONCE") &&
                    getValues("latefee_max") && (
                      <>
                        {getValues("latefee_unit") == "Amount" ? "$" : ""}
                        {Number(getValues("latefee_max")).toFixed(2)}
                        {getValues("latefee_unit") == "Percentage" ? "%" : ""}
                      </>
                    )}
                  {!showLateFeeSetting &&
                    paymentFrequencyPermitted.includes("ONCE") && (
                      <Controller
                        name="latefee_paymentfrequency_ONCE"
                        render={({ field, fieldState: { error } }) => (
                          <CustomProductNumberTextField
                            {...field}
                            small
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1}></Grid>
              </Grid>
            </>
          )}
        {subType == "mortgage" && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <FieldTitle title="Mortgage Type" />
                <Controller
                  name="loan_type"
                  control={control}
                  render={({ field }) => (
                    <CustomProductCheckboxGroup
                      {...field}
                      selected={selectedLoanType}
                      handleChange={handleChangeLoanType}
                      optionlist={loanTypeOptions}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}>
                <FieldTitle title="Mortgage Amortization" />
                <Controller
                  name="loan_amortization"
                  control={control}
                  render={({ field }) => (
                    <CustomProductCheckboxGroup
                      {...field}
                      selected={selectedAmortization}
                      handleChange={handleChangeLoanType}
                      optionlist={loanAmortizationOptions}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </>
        )}
        {(subType == "account" ||
          productModulesGroup?.includes("product-account-service")) && (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FieldTitle title="Account Services Offered" />
                <Controller
                  name="account_services_offered"
                  control={control}
                  render={({ field }) => (
                    <CustomProductCheckboxGroup
                      {...field}
                      selected={selectedAccountService}
                      handleChange={handleChangeAccountService}
                      optionlist={accountserviceOptions}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <FieldTitle title="Minimum Starting Balance ($)" />
              </Grid>
              <Grid item xs={9}>
                <Controller
                  name="min_verify_amount"
                  defaultValue={data?.min_verify_amount || ""}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <CustomProductNumberTextField {...field} small />
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <FieldTitle title="Beneficiary" />
              </Grid>
              <Grid item xs={10}>
                {/* sBeneficiary, YES,NO */}
                <Controller
                  name="sBeneficiary"
                  control={control}
                  defaultValue={data?.sBeneficiary || "NO"}
                  render={({ field }) => (
                    <CustomProductSelect
                      {...field}
                      small
                      variant="outlined"
                      optionlist={[
                        { value: "NO", label: "Not Accepted" },
                        { value: "YES", label: "Accepted" },
                      ]}
                      onChange={(e) => {
                        field.onChange(e.target.value);
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </>
        )}
        {/* Save Button */}
        <Grid container>
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            Payment Due Date
          </Typography>
          <Grid item xs={12}>
            <Controller
              name="sAllowPaymentDueDate"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value === "YES"}
                      color="primary"
                      onChange={(e) => {
                        field.onChange(e.target.checked ? "YES" : "NO");
                      }}
                    />
                  }
                  label={"Ask application for preferred payment due date"}
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
      <CustomProductActionBottom>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(handleSaveClick)}
          disabled={!isDirty || hasAmountOrTermErrors}
          // disabled={!isDirty && !showSubmitButton}
          sx={{ width: "120px", mt: 1 }}
        >
          Save
        </Button>
      </CustomProductActionBottom>
    </SectionStyled>
  );
}
